/** @format */

import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DataTable from "./DataTable";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";

const vendorColumns = [
  {
    field: "vendorId",
    headerName: "Vendor Id",
    width: 150,
    renderCell: (params) => {
      return (
        <NavLink to={`/vendor/${params.row.vendorId}`}>
          {params.row.vendorId}
        </NavLink>
      );
    },
  },
  {
    field: "vendorName",
    headerName: "Vendor Name",
    width: 200,
  },
  {
    field: "vendorEmail",
    headerName: "Vendor Email",
    width: 250,
  },
  {
    field: "mobileNo",
    headerName: "Mobile Number",
    width: 150,
  },
];

const VendorList = () => {
  const [vendors, setVendors] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  async function deleteVendors(vendorList) {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/v1/vendor`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(
            localStorage.getItem("accessToken")
          )}`,
        },
        data: vendorList
      })
      console.log(response.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function getListOfVendors() {
    setIsFetching(true);
    try {
      const vendorListResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/vendor/all`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(vendorListResponse.data);
      const formatedVendorList = vendorListResponse.data.map((vendor) => {
        return {
          id: vendor.vendorId,
          vendorId: vendor.vendorId,
          vendorName: vendor.vendorName,
          vendorEmail: vendor.vendorEmail,
          mobileNo: vendor.mobileNo,
        };
      });
      setVendors(formatedVendorList);
    } catch (err) {
      console.log(err);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    getListOfVendors();
  }, []);

  return (
    <>
      {isFetching ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <>
          <Alert
            severity="success"
            color="success"
            sx={{ my: 2 }}
            iconMapping={{
              success: <FormatListBulletedIcon fontSize="inherit" />,
            }}>
            <Typography component="h1" variant="h6">
              List of Vendors
            </Typography>
          </Alert>
          <DataTable
            rows={vendors}
            columns={vendorColumns}
            updateList={setVendors}
            deleteList={deleteVendors}
          />
        </>
      )}
    </>
  );
};

export default VendorList;
